import { withErrorLogger } from '@move-frontend/auth';
import { cognitoClient } from '../../../../shared/api/cognito';
import { logError } from '../../../../shared/error/logError';
import { ISignOutData } from '../models/ISignOutData';
import { trackSignOut } from './helpers/trackSignOut';
import { setUserLoginStatusProperty } from '../../../../shared/analytics/user/useSetUserProperties';

async function performSignOut({ redirect }: ISignOutData = {}) {
	await cognitoClient.signOut();

	trackSignOut();
	setUserLoginStatusProperty(false);

	if (!redirect) {
		return;
	}

	await redirect();
}

export const signOut = withErrorLogger(performSignOut, {
	customLogError: logError,
});
